import React from 'react';
import { LoaderSubmitButton } from '../../../components/LoaderSubmitButton';

export const CompleteTradeButton = ({ jobId, loading, updateStatus }) => (
  <LoaderSubmitButton
    data-test-id={`complete-trade-${jobId}`}
    loading={loading}
    size="small"
    color="primary"
    onClick={() => {
      updateStatus(jobId, 'completed');
    }}
  >
    Complete
  </LoaderSubmitButton>
);
